import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { DesktopNav } from './header/DesktopNav';
import { MobileMenu } from './header/MobileMenu';

export const Header = () => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  const MenuIcon = isMenuOpen ? X : Menu;

  return (
    <>
      <header className="nav-header">
        <Link to="/" className="nav-logo" data-testid="nav-logo">
          Elina K.
        </Link>

        <DesktopNav pathname={pathname} />

        <button
          onClick={() => setIsMenuOpen(open => !open)}
          className="menu-toggle"
          aria-label="Toggle menu"
          data-testid="menu-toggle"
        >
          <MenuIcon className="w-6 h-6 text-white" />
        </button>
      </header>

      <MobileMenu isOpen={isMenuOpen} pathname={pathname} onClose={closeMenu} />
    </>
  );
};
